import { useDrop } from "react-dnd";

const useVerticalEvent = ({ handleDropOnEventCb, record }) => {
  const [, drop] = useDrop(
    () => ({
      accept: "item-on-event",
      drop: (item) => {
        handleDropOnEventCb({ ...record, ...item });
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    []
  );

  return { drop };
};

export default useVerticalEvent;
